export default [
  {
    path: '/main/ostests',
    meta: {
      tag: 'list_ostest',
      name: 'Testes',
      breadcrumb: 'Testes'
    },
    component: () => import(/* webpackChunkName: "osTests-list" */ '@/views/main/osTests/Index.vue'),
    children: [
      {
        path: '',
        name: 'listostests',
        meta: {
          tag: 'list_ostest',
          menu: 'ostests',
          name: 'Testes'
        },
        component: () => import(/* webpackChunkName: "osTests-list" */ '@/views/main/osTests/List.vue')
      },
      {
        path: 'test/:id',
        name: 'editostests',
        meta: {
          tag: 'edit_ostest',
          menu: 'ostests',
          name: 'Testar | Ordem de serviço',
          breadcrumb: 'Testar Ordem de serviço'
        },
        component: () => import(/* webpackChunkName: "osTests-edit" */ '@/views/main/osTests/Test.vue')
      }
    ]
  }
]
